import axios from 'axios';
import { getLiveChatServerRestApiUrl } from '../urlFactory';

let chatClient;

export default class LiveChatRestClient {
	constructor() {
		this.baseUrl = getLiveChatServerRestApiUrl();
	}

	static init(data) {
		chatClient = data.chatClientObj;
	}

	// Helper method to construct full URL
	getFullUrl(endpoint) {
		return `${this.baseUrl}/api/v1${endpoint}`;
	}

	// Helper method for making API calls
	async makeRequest(method, endpoint, data) {
		try {
			const response = await axios({
				method,
				url: this.getFullUrl(endpoint),
				data
			});
			return response.data;
		} catch (error) {
			console.error(`API Error (${endpoint}):`, error.message);
			throw error;
		}
	}

	async addContactToUser(userId, contactEmail) {
		try {
			const response = await this.makeRequest("post", "/contacts/addContact", {
				userId,
				contactEmail,
			});

			return {
				success: true,
				data: response
			};
		} catch (error) {
			return {
				success: false,
				error: 'Invalid contact' // || error.message
			};
		}
	}

	async addGroup(userId, newGroup) {
		try {
			const response = await this.makeRequest("post", "/groups/createGroup", {
				userId,
				groupName: newGroup.groupName,
				groupType: newGroup.groupType,
				members: newGroup.members,
			});

			// Check if response indicates failure
			if (!response.success) {
				return {
					success: false,
					error: response.message
				};
			}

			// Handle partial success (some members couldn't be added)
			if (response.data?.failedMembers?.length > 0) {
				return {
					success: true,
					data: response.data.group,
					partialSuccess: true,
					failedMembers: response.data.failedMembers,
					message: response.message
				};
			}

			// Handle complete success
			return {
				success: true,
				data: response.data.group,
				message: response.message
			};
		} catch (error) {
			// Handle network or unexpected errors
			if (error.response?.data) {
				// If we have a structured error response from the server
				return {
					success: false,
					error: error.response.data.message
				};
			}

			return {
				success: false,
				error: error.message || 'Failed to create group'
			};
		}
	}

}
